import { useState } from 'react'
import { InventoryLocation, Branch } from 'inventory-web'
import { heapEvent } from '@equipmentshare/heaper'
import useMoveInventoryLocationHandler from '../../../effects/moveInventoryLocation'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
	EuiSpacer,
} from '@equipmentshare/ds2'
import BranchPicker from 'components/BranchPicker'

export type FormValidation = {
	isInvalid: boolean,
	error?: string,
}

export function validateBranch( inventoryLocation: InventoryLocation, selectedBranch?: Branch ): FormValidation {
	if ( !selectedBranch ) {
		return {
			isInvalid: true,
			error: 'You must select a branch',
		}
	}

	if ( selectedBranch.id === inventoryLocation.branch.id ) {
		return {
			isInvalid: true,
			error: 'You must select a different branch',
		}
	}

	return {
		isInvalid: false,
	}
}

export type MoveInventoryLocationModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	inventoryLocation: InventoryLocation,
	updateAfterMove: ( oldInventoryLocationId: string, movedInventoryLocation: InventoryLocation, fromBranchId: number, toBranchId: number ) => void,
}

export default function MoveInventoryLocationModal( { onCancel, onSuccess, inventoryLocation, updateAfterMove }: MoveInventoryLocationModalProps ) {
	const [ selectedBranch, setSelectedBranch ] = useState<Branch>()
	const [ branchValidation, setBranchValidation ] = useState<FormValidation>( { isInvalid: false } )
	const [ isSaving, setIsSaving ] = useState( false )
	const moveLocation = useMoveInventoryLocationHandler( updateAfterMove )

	const onChangeBranch = ( _?: number, option?: Branch ) => {
		setSelectedBranch( option )
		setBranchValidation( { isInvalid: false } )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Move Store Modal - Click - Cancel', {} )
		onCancel()
	}

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Move Store Modal - Click - Submit', {} )

		setIsSaving( true )
		const validation = validateBranch( inventoryLocation, selectedBranch )
		if ( validation.isInvalid || !selectedBranch ) {
			setBranchValidation( validation )
			setIsSaving( false )
		} else {
			try {
				await moveLocation( inventoryLocation, selectedBranch.id )
				onSuccess()
			} catch ( e: unknown ) {
				setIsSaving( false )
			}
		}
	}

	return (
		<>
			<EuiModalBody>
				<div>
					<p>Current branch</p>
					<p style={{ fontWeight: 'bold', paddingTop: '8px' }}>{inventoryLocation.branch.name}</p>
				</div>
				<EuiSpacer size="l" />

				<BranchPicker
					label="Move to"
					selectedBranch={selectedBranch}
					onChange={onChangeBranch}
					formRowProps={branchValidation}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
